import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { FieldArray } from 'formik';
import { getTranslatedString, getCurrentLocale } from 'helpers/i18n';
import { media } from 'helpers/MediaHelper';

import Col from 'components/ui/Col';
import Row from 'components/ui/Row';
import Spacer from 'components/ui/Spacer';
import Form from 'components/ui/Form';
import { DatePicker } from 'antd';
import { colors } from 'helpers/ColorHelper';

const { RangePicker } = DatePicker;

const StyledMt = styled(Col)`
  ${media.mobile`
    margin-top: 1rem;
  `};
`;

const StyledAddRemove = styled.span`
  color: ${colors.BLUE};
  textalign: 'left';
  fontsize: '14px';
  cursor: 'pointer';
`;

const StyledText = styled.span`
  font-size: 14px;
  margin-bottom: '2em';
`;

const EffectiveDatesInput = ({ values, errors, touched, setFieldValue }) => {
  const renderEffectiveDateRanges = (arrayHelpers) => {
    const renderFirstButton = () => {
      return (
        <StyledAddRemove onClick={() => arrayHelpers.push([null, null])}>
          {getTranslatedString('landlordPortal.noticeForm.effectiveDates.add')}
        </StyledAddRemove>
      );
    };

    const renderExistingRanges = () => {
      return values.effective_dates.map((range, index) => {
        return (
          <>
            <Row key={index}>
              <Form.Item>
                <RangePicker
                  name={`effective_dates.${index}`}
                  value={range}
                  mobileMode="date"
                  showTime={{
                    format: 'h:mm a',
                  }}
                  format="YYYY-MM-DD h:mm a"
                  showToday={false}
                  defaultPickerValue={moment().locale(getCurrentLocale())}
                  disabledDate={(current) => current < moment().startOf('day')}
                  style={{ width: '100%' }}
                  onChange={(newValues) => {
                    setFieldValue(`effective_dates.${index}`, newValues);
                  }}
                />
                <StyledAddRemove onClick={() => arrayHelpers.remove(index)}>
                  {getTranslatedString('landlordPortal.noticeForm.effectiveDates.remove')}
                </StyledAddRemove>
              </Form.Item>
            </Row>
            {index === values.effective_dates.length - 1 && (
              <Row>
                <StyledAddRemove onClick={() => arrayHelpers.push([null, null])}>
                  {getTranslatedString('landlordPortal.noticeForm.effectiveDates.add')}
                </StyledAddRemove>
              </Row>
            )}
          </>
        );
      });
    };

    return (
      <>
        {values.effective_dates && values.effective_dates.length > 0
          ? renderExistingRanges()
          : renderFirstButton()}
      </>
    );
  };

  return (
    <StyledMt sm={24}>
      <StyledText>{getTranslatedString('landlordPortal.noticeForm.selectOneOrMany')}</StyledText>
      <Spacer mb={1} />
      <FieldArray name="effective_dates" render={renderEffectiveDateRanges} />
    </StyledMt>
  );
};

export default EffectiveDatesInput;
